export enum CompanyPortfolioTranslations {
  portfolioTitle = 'companyPortfolio.portfolioTitle',

  productAndServices = 'companyPortfolio.productAndServices',

  modalTitle = 'companyPortfolio.modalTitle',
  modalPortfolioPlaceholderText = 'companyPortfolio.modalPortfolioPlaceholderText',
}
